var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPpgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg3689",
    viewBox: "0 0 295.09528 228.7821",
    height: "64.56739mm",
    width: "83.282448mm",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3691"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath84",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path86",
    d: "m 507.84,62.923 85.385,0 0,66.198 -85.385,0 0,-66.198 z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-269.49164,-422.09628)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath84)",
    id: "g82",
    transform: "matrix(3.4560636,0,0,-3.4560636,-1485.6357,868.34425)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(578.9538,62.9223)",
    id: "g88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path90",
    style: {
      fill: "#0272a6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 -56.842,0 c -7.85,0 -14.272,6.422 -14.272,14.271 l 0,37.656 c 0,7.849 6.422,14.271 14.272,14.271 l 56.842,0 c 7.85,0 14.271,-6.422 14.271,-14.271 l 0,-37.656 C 14.271,6.422 7.85,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(550.5578,92.6842)",
    id: "g92"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path94",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -3.743,0 -6.154,1.751 -6.154,1.751 l 0,20.183 c 0,1.683 1.992,2.839 3.695,3.052 C -0.634,25.213 7.774,26.481 7.774,13.252 7.774,1.33 2.107,0 0,0 m -27.513,1.247 c -2.479,0 -3.505,1.078 -3.505,1.078 l 0,12.167 c 0,1.037 0.748,1.749 1.876,1.879 1.209,0.14 6.704,1.018 6.704,-7.129 0,-7.628 -3.355,-7.995 -5.075,-7.995 m 56.518,13.624 c 3.412,1.009 6.882,-0.035 9.636,-2.321 l 0,7.335 c -8.901,1.411 -13.565,0.451 -17.125,-1.758 -2.887,-1.845 -4.113,-4.362 -4.113,-4.362 0,0 -0.064,-0.134 -0.17,-0.374 -0.467,18.563 -11.825,16.946 -25.38,16.942 -3.8,-10e-4 -7.634,0 -7.634,0 l 0,-15.996 c -2.252,6.621 -9.208,5.909 -16.652,5.909 -2.696,0 -6.259,-10e-4 -6.259,-10e-4 l 0,-33.841 10.252,0 c -1.71,0.594 -2.578,2.078 -2.578,4.232 l 0,9.297 2.958,-2.957 c 1.304,-0.319 2.445,-0.284 2.445,-0.284 2.831,0.156 7.919,1.253 9.834,6.99 l 0,-27.38 12.198,0 c -1.705,0.593 -2.571,2.048 -2.571,4.196 l 0,18.385 4.624,-4.607 c 1.493,-0.536 2.592,-0.625 3.852,-0.568 3.559,0.223 9.65,1.726 12.84,8.159 0.263,-6.047 2.244,-12.114 8.379,-14.498 2.701,-1.104 5.771,-1.411 8.963,-1.166 2.086,0.062 4.11,0.247 6.137,0.613 l 0,16.577 -9.343,-0.002 c 1.711,-0.595 2.578,-2.002 2.578,-4.156 l 0,-7.55 c -2.13,-0.666 -5.009,-0.009 -6.616,2.068 -2.028,2.623 -2.395,10.006 -1.534,15.042 0.49,2.516 2.645,5.298 5.279,6.076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpgLogo);
export default __webpack_public_path__ + "static/media/PPG_Logo.4271bf9f24df9c84dac4779b27152ac3.svg";
export { ForwardRef as ReactComponent };